import { useShowContext } from 'framework/show';
import { StaffingDataType, STAFFING_PRIORIRY_ZONES_ALIASES } from 'domain/shared/staffing';
import NotificationsRounded from '@mui/icons-material/NotificationsRounded';
import OpenWithRounded from '@mui/icons-material/OpenWithRounded';
import PersonRounded from '@mui/icons-material/PersonRounded';
import WarningRounded from '@mui/icons-material/WarningRounded';
import { useDashboardModals } from 'framework/ui/dashboard';
import { useZonesManagement } from './useZonesManagement';
import { useStaffingCoordinatorManagement } from './useStaffingCoordinatorManagement';
import { ZONE_LABELS } from 'domain/staffing/dashboard/constants';

export const useMenuOptions = () => {
  const { data } = useShowContext<StaffingDataType>();
  const { openModal } = useDashboardModals();
  const { zoneOptions } = useZonesManagement();
  const projectData = data.getData();
  const { coordinatorOptions, hasChangePermission } = useStaffingCoordinatorManagement();

  const currentZone = projectData?.staffingRisk?.priority;

  const menuOptions = [
    {
      key: 'issues',
      label: 'Issues',
      icon: <WarningRounded fontSize="small" />,
      onClick: () => {
        openModal('issues', { projectData });
      },
    },
    {
      key: 'followUp',
      label: 'Follow-up',
      onClick: () => {
        openModal('followUp', { projectData });
      },
      icon: <NotificationsRounded fontSize="small" />,
    },
    ...(hasChangePermission
      ? [
          {
            key: 'change-staffing-coordinator',
            label: 'Staffing',
            expandable: true,
            subOptions: coordinatorOptions,
            icon: <PersonRounded fontSize="small" />,
          },
        ]
      : []),
    {
      key: 'changeZone',
      label: ZONE_LABELS[currentZone as keyof typeof STAFFING_PRIORIRY_ZONES_ALIASES],
      expandable: true,
      subOptions: zoneOptions,
      icon: <OpenWithRounded fontSize="small" />,
    },
  ];

  return {
    menuOptions,
  };
};
